import {
  Box,
  FormControlLabel,
  Stack,
  Switch,
  TextField,
  Tooltip,
} from "@mui/material";

import { EquipmentTypeMultiSelect } from "components/EquipmentTypeSelect";
import { ProvinceStateMultiSelect } from "components/ProvinceStateMultiSelect";
import { ShipmentServiceMultiSelect } from "components/ShipmentServiceMultiSelect";

import { LaneExpiryDateField } from "../LaneExpiryDateField";

import type { LaneFormState } from "../../utils";

interface Props {
  value: LaneFormState;
  onChange: (patch: Partial<LaneFormState>) => void;
  nameRequired?: boolean;
}

export function LaneFormFields(props: Props) {
  const { value, onChange, nameRequired = false } = props;

  return (
    <>
      <TextField
        fullWidth
        label={nameRequired ? "Lane Name" : "Lane Name (Optional)"}
        value={value.name}
        onChange={(e) => onChange({ name: e.target.value })}
        sx={{ mb: 2 }}
        size="small"
      />
      <Stack direction="row" spacing={1.5} sx={{ mb: 1.5 }}>
        <Box sx={{ flex: 1 }}>
          <EquipmentTypeMultiSelect
            onChange={(equipmentTypes) => onChange({ equipmentTypes })}
            value={value.equipmentTypes}
            defaultValue={value.equipmentTypes}
          />
        </Box>
        <Box sx={{ flex: 1 }}>
          <ShipmentServiceMultiSelect
            label="Service Type"
            value={value.services}
            onChange={(services) => onChange({ services })}
          />
        </Box>
      </Stack>
      <Stack direction="row" spacing={1.5}>
        <Box sx={{ flex: 1 }}>
          <ProvinceStateMultiSelect
            label="Origin"
            value={value.originProvinces}
            onChange={(originProvinces) => onChange({ originProvinces })}
          />
        </Box>
        <Box sx={{ flex: 1 }}>
          <ProvinceStateMultiSelect
            label="Destination"
            value={value.destinationProvinces}
            onChange={(destinationProvinces) =>
              onChange({ destinationProvinces })
            }
          />
        </Box>
      </Stack>
      <Tooltip title="Off, the lane keeps matching new loads indefinitely. On, it stops after the day you pick. You can change this any time.">
        <FormControlLabel
          control={
            <Switch
              checked={value.hasExpiry}
              onChange={(e) => onChange({ hasExpiry: e.target.checked })}
            />
          }
          label="Set an expiry date"
          sx={{ mt: 1 }}
        />
      </Tooltip>
      {value.hasExpiry && (
        <LaneExpiryDateField
          label="Expires On"
          tooltip="The lane stops matching new loads after the end of this day."
          value={value.expiresOn}
          onChange={(expiresOn) => onChange({ expiresOn })}
        />
      )}
    </>
  );
}
